import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { skipToken } from '@reduxjs/toolkit/query';
import {
  setCustomSurvey as setCS,
  setBookingSurvey as setBS,
  setTicketsSurvey as setTS,
  setMerchSurvey as setMS,
  restore,
} from './surveys.slice';
import {
  useGetBookingSurveyQueryState,
  useLazyGetBookingSurveyQuery,
} from './surveys.api';

export default function useSurveys() {
  const { event } = useSelector((state) => state.event || { event: {} });
  const dispatch = useDispatch();
  const { data: questions } = useGetBookingSurveyQueryState(
    event.id || skipToken,
  );

  const [trigger] = useLazyGetBookingSurveyQuery();

  const surveys = useSelector((state) => state.surveys);
  const [hasQuestions, setHasQuestions] = useState(false);
  const [questionsByID, setQuestionsByID] = useState();

  useEffect(() => {
    if (questions) {
      let questionsIDs = {};

      if (questions?.questions_by_booking) {
        Object.values(questions.questions_by_booking).map((q) => {
          questionsIDs = {
            ...questionsIDs,
            [`${q.id}`]: q,
          };
        });
      }
      if (questions?.questions_by_ticket) {
        Object.values(questions.questions_by_ticket).map((q) => {
          questionsIDs = {
            ...questionsIDs,
            [`${q.id}`]: q,
          };
        });
      }
      setQuestionsByID(questionsIDs);
      setHasQuestions(
        (questions?.questions_by_booking &&
          questions?.questions_by_booking.length > 0) ||
          (questions?.questions_by_ticket &&
            questions?.questions_by_ticket.length > 0),
      );
    }
  }, [questions]);

  const setCustomSurvey = (survey) => {
    dispatch(setCS(survey));
  };
  const setBookingSurvey = (survey) => {
    dispatch(setBS(survey));
  };
  const setTicketsSurvey = (survey) => {
    dispatch(setTS(survey));
  };
  const setMerchSurvey = (survey) => {
    dispatch(setMS(survey));
  };
  const reset = () => {
    dispatch(restore());
  };

  const loadBookingSurvey = async () => {
    await trigger(event.id);
  };

  return {
    surveys,
    questions,
    questionsByID,
    hasQuestions,
    setCustomSurvey,
    setBookingSurvey,
    setTicketsSurvey,
    setMerchSurvey,
    loadBookingSurvey,
    reset,
  };
}
